"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicVideoService = void 0;
const tslib_1 = require("tslib");
const queries_1 = require("./queries");
const base_public_service_1 = require("../base-public-service");
const play_urls_1 = require("../../mappers/play-urls");
const mappers_1 = require("../channel/mappers");
class PublicVideoService extends base_public_service_1.BasePublicService {
    getDownloadUrl(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.client.request(queries_1.GET_DOWNLOAD_URL, { id });
            return response.video.download.entity.url;
        });
    }
    getPlayUrls(variables) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const result = yield this.client.request(queries_1.GET_SINGLE_VIDEO_PLAY_URLS, variables);
            return (0, play_urls_1.toPlayUrls)(result.video.play.entity.hls);
        });
    }
    getVideo(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { video } = yield this.client.request(queries_1.GET_PUBLIC_VIDEO, {
                id,
            });
            return (0, mappers_1.mapGqlPublicVideoToOld)(video);
        });
    }
}
exports.PublicVideoService = PublicVideoService;
//# sourceMappingURL=video.js.map